import React, { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import moment from 'moment';
import { styles, useStyles } from './EditCommunicationProgramStyles';
import { Modal, Select, Input, Icon, DatePicker, Button, Tooltip, Table, Badge, Tabs, Checkbox, Row, Col, message, Spin } from 'antd';
import CourseAvailableContainer from 'app/containers/CourseAvailableContainer';
import ModalProcedureAssignation from '../CreateCommunicationProgram/ModalProcedureAssignation/ModalProcedureAssignation';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import ContractContainer from 'app/containers/ContractContainer';
import WorkContainer from 'app/containers/WorkContainer';
import ApiService from 'app/services/ApiService'
import searchMultiple from 'app/utils/SearchMultiple';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCommunicationProgram,
    clearCommunicationProgram,
    comunicationProgramDiffusionClear,
    clearcommunicationProgramFilter,
    fetchCommunicationProgramFilter,
    getEmployeesBycategory,
    getEmployeesByIdEmployee,
    getEmployeeLayout,
    postEmployeeLayout,
} from 'app/actions/CommunicationProgramActions';
import { employeeById } from 'app/reducers';
import Highlighter from 'react-highlight-words';
import { removeCourseUsed } from '../../actions/CourseAvailableActions';
import { Paper } from '@material-ui/core';

import AttachFileXLSX from 'app/containers/AttachFileXLSX/AttachFileXLSX';

const { TextArea } = Input;
const { confirm } = Modal;
const { RangePicker } = DatePicker
const { TabPane } = Tabs;

export default function EditCommunicationProgram(props) {
    /**INICIO. Declaraciones genéricas */
    const classes = useStyles();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [oilTraining, setOilTraining] = useState(false);
    const [disableDif, setDisableDif] = useState(false);
    const [disabledCP, setDisabledCP] = useState(false);
    const [showValid, setShowValid] = useState(true);
    /**FIN. */

    /**INICIO. Selectores*/
    const employeeData = useSelector(employeeById);

    const {
        siteId
    } = useSelector(state => state.Auth)

    const {
        trainingSelect,
        isLoadTrainingSelect
    } = useSelector(state => state.TrainingReducer);

    const {
        listExternalEmployees,
        isLoadingExternalEmployees,
        listEmployeesByCategory,
        isLoadingEmployeesByCatagory,
        listEmployeesByIdEmployee,
        isLoadListEmployeesById,
        isLoadingDiffusion,
        allIds
    } = useSelector(state => state.CommunicationProgram);
    /**FIN. */

    /**INICIO. Menú*/
    const [open, setOpen] = useState(false);
    const [isCommunicationProgram, setCommunicationProgramStatus] = useState(false);
    /**FIN.  */

    /**INICIO. Declaraciones Datos generales*/
    const [id, setId] = useState(null);
    const [name, setName] = useState('');
    const [description, setDesc] = useState('');
    const [folio, setFolio] = useState('');
    const [contract, setContract] = useState(undefined);
    const [work, setWork] = useState(undefined);
    const [oilService, setOilService] = useState(false);
    const [estatus, setEstatus] = useState();
    const [isLoaded, setLoadData] = useState(false);
    const [idTraining, setIdTraining] = useState(undefined);
    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );
    /**FIN. */

    /**INICIO. Declaraciones Difusiones*/
    const [questions, setQuestions] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [notApply, setNotApply] = useState(false);
    const [isLoadedDiffusion, setIsLoadedDiffusion] = useState(false);
    const [activeKey, setTabBar] = useState('1');
    /**FIN.  */

    /**INICIO. Declaraciones Modal de Procedimiento(s) / Material de Capacitación*/
    const [visibleModalProcedureAssign, setVisibleModalProcedureAssign] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    /**FIN.  */

    /**INICIO. Declaraciones Modal Asignación / Designación de empleados*/
    const [visibleModalEditAssignment, setVisibleModalEditAssignment] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [selectedRowsFile, setSelectedRowsFile] = useState([]);
    const [selectedRowKeysFile, setSelectedRowKeysFile] = useState([]);

    const [selectedRowKeysAvailableFile, setSelectedRowKeysAvailableFile] = useState([]);
    const [selectedRowsAvailableFile, setSelectedRowsAvailableFile] = useState([]);

    const [selectedRowsExternal, setSelectedRowsExternal] = useState([]);
    const [selectedRowKeysExternal, setSelectedRowKeysExternal] = useState([]);

    const [selectedRowKeysAvailableExternal, setSelectedRowKeysAvailableExternal] = useState([]);
    const [selectedRowsAvailableExternal, setSelectedRowsAvailableExternal] = useState([]);

    const [selectedRowsFileAssig, setSelectedRowsFileAssig] = useState([]);
    const [selectedRowKeysFileAssig, setSelectedRowKeysFileAssig] = useState([]);

    const [selectedRowKeysAvailableFileAssig, setSelectedRowKeysAvailableFileAssig] = useState([]);
    const [selectedRowsAvailableFileAssig, setSelectedRowsAvailableFileAssig] = useState([]);

    const [selectedRowsExternalAssig, setSelectedRowsExternalAssig] = useState([]);
    const [selectedRowKeysExternalAssig, setSelectedRowKeysExternalAssig] = useState([]);

    const [selectedRowKeysAvailableExternalAssig, setSelectedRowKeysAvailableExternalAssig] = useState([]);
    const [selectedRowsAvailableExternalAssig, setSelectedRowsAvailableExternalAssig] = useState([]);

    const [employeesAssigFile, setEmployeesAssigFile] = useState([]);
    const [employeesAssigExternal, setEmployeesAssigExternal] = useState([]);

    const [diploma, setDiploma] = useState(undefined)
    /**FIN.  */

    //LAYOUT INICIO
    const [localAttachment, setAttachment] = useState();
    const [dataExcel, setDataExcel] = useState([]);
    const [loadDocument, setLoadDocument] = useState(false);
    const [isLoadingLayout, setIsLoadingLayout] = useState(false);

    //LAYOUT FIN

    /**INICIO. DataSource Tablas*/
    const dataSourceCourse = questions[selectedIndex] !== undefined ? questions[selectedIndex].listCoursesAssigned.map( //Tabla de procedimientos
        (record) => {
            return {
                'key': record.idCourse,
                'nameWithCode': record.nameWithCode,
                'category': record.category,
                'file': record.file,
                'external': record.external
            }
        }
    ) : [];

    const dataSourceCategories = listEmployeesByCategory.map( //Empleados por puesto
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    );

    const dataSourceFile = listEmployeesByIdEmployee.filter(x => !employeesAssigFile.map(y => y.employeeId).includes(x.employeeId)).map( //Empleados por ficha disponibles
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    )

    const dataSourceFileAssig = employeesAssigFile.map( //Empleados por ficha asignados
        (record) => {
            return {
                'key': record.employeeId,
                'fullName': record.fullName,
                'employeeId': record.employeeId,
                'categoryName': record.categoryName,
                'companyName': record.companyName
            }
        }
    )

    const dataSourceExternal = listExternalEmployees.filter(x => !employeesAssigExternal.map(y => y.employeeId).includes(x.employeeId)).map( //Empleados externos disponibles
        (record) => {
            return {
                'key': record.employeeId,
                'employeeId': record.employeeId,
                'fullName': record.fullName,
                'userName': record.userName,
                'email': record.email,
                'expirationDate': record.expirationDate,
                'rol': record.rol
            }
        }
    )

    const dataSourceExternalAssig = employeesAssigExternal.map( //Empleados externos asignados
        (record) => {
            return {
                'key': record.employeeId,
                'employeeId': record.employeeId,
                'fullName': record.fullName,
                'userName': record.userName,
                'email': record.email,
                'expirationDate': record.expirationDate,
                'rol': record.rol
            }
        }
    )
    /**FIN.  */

    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Buscar... ejemplo1;ejemplo2;`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters, setSelectedKeys)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            searchMultiple(value?.split(";").filter(x => x != ""), record[dataIndex]
                .toString()
                .toLowerCase()),
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    const columnsLayout = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            width: 300,
            ellipsis: true,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            width: 110,
            ellipsis: true,
            ...getColumnSearchProps('employeeId')
        }
    ];

    /**INICIO. Métodos para el renderizado de columnas*/
    const setExpirationDateColor = (record) => {
        if (moment(record.expirationDate).isSameOrAfter(moment()) && moment(record.expirationDate).isBefore(moment().add(3, 'days')))
            return "warning"
        if (moment(record.expirationDate).isSameOrAfter(moment().add(3, 'days')))
            return "success"
        return "error"
    }

    const setRolColor = (record) => {
        return record.rol ? "success" : "error";
    }

    const setColor = (hasAssigned) => hasAssigned ? "success" : "default";
    /**FIN.  */

    /**INICIO. Columnas de las tablas (Procedimientos, empleados por categoria, ficha, externos)*/
    const columnsExternal = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            width: 300,
            ellipsis: true,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Usuario',
            dataIndex: 'userName',
            key: 'userName',
            width: 110,
            ellipsis: true,
            ...getColumnSearchProps('userName')
        },
        {
            title: 'Correo',
            dataIndex: 'email',
            key: 'email',
            ellipsis: true,
            width: 150,
            ...getColumnSearchProps('email'),
        },
        {
            title: 'Vigencia',
            key: 'expiration',
            dataIndex: 'expirationDate',
            fixed: 'right',
            width: 50,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setExpirationDateColor(record)} />
                    </Col>
                </Row>
            )
        },
        {
            title: 'Rol',
            key: 'rol',
            dataIndex: 'rol',
            fixed: 'right',
            width: 50,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setRolColor(record)} />
                    </Col>
                </Row>
            )
        }
    ];

    const columns = [
        {
            title: 'Procedimiento(s) / Material de Capacitación Asignado(s)',
            dataIndex: 'nameWithCode',
            key: 'nameWithCode',
            ellipsis: true,
            ...getColumnSearchProps('nameWithCode')
        }, {
            title: 'Puesto',
            key: 'category',
            dataIndex: 'category',
            width: 75,
            ellipsis: true,
            align: 'center',
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.category)} />
                    </Col>
                </Row>
            )
        }, {
            title: 'Ficha',
            key: 'file',
            dataIndex: 'file',
            align: 'center',
            width: 75,
            ellipsis: true,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.file)} />
                    </Col>
                </Row>
            )
        }, {
            title: 'Externo',
            key: 'external',
            dataIndex: 'external',
            align: 'center',
            ellipsis: true,
            width: 75,
            render: (text, record) => (
                <Row>
                    <Col offset={7}>
                        <Badge status={setColor(record.external)} />
                    </Col>
                </Row>
            )
        }
    ];

    const columnsCategory = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            ellipsis: true,
            width: 300,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('employeeId')
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('categoryName')
        },
        {
            title: 'Compañia',
            dataIndex: 'companyName',
            key: 'companyName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('companyName')
        }
    ];

    const columnsCategoryFile = [
        {
            title: 'Nombre',
            dataIndex: 'fullName',
            key: 'fullName',
            ellipsis: true,
            width: 300,
            ...getColumnSearchProps('fullName')
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('employeeId')
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('categoryName')
        },
        {
            title: 'Compañia',
            dataIndex: 'companyName',
            key: 'companyName',
            ellipsis: true,
            width: 170,
            ...getColumnSearchProps('companyName')
        }
    ];
    /**FIN.  */

    /**INICIO. */
    /**FIN.  */

    /**INICIO. */
    /**FIN.  */

    /**INICIO. */
    /**FIN.  */

    const removeAssigned = (item) => {
        dispatch(removeCourseUsed(item));
    }

    const handleClick = () => {
        setOpen(!open);
    }

    const addQuestion = () => {
        const key = questions.length <= 0 ? 0 : questions.length;
        questions.find(i => {
            return i.activeKey.isActive = false;
        });

        let question = [...new Set(questions.concat({
            idCommunicationProgram: id,
            diffusionName: 'Difusión ' + (questions.length + 1),
            vigency: questions.length === 0 ?
                [
                    moment(moment().add('days', questions.length).format('DD/MM/YYYY'), 'DD/MM/YYYY'),
                    moment(moment().add('days', 1).format('DD/MM/YYYY'), 'DD/MM/YYYY')
                ] :
                [
                    moment(questions[questions.length - 1].vigency[1]._i, 'DD-MM-YYYY'),
                    moment(moment(questions[questions.length - 1].vigency[1]._i, 'DD-MM-YYYY').add('days', 1).format('DD/MM/YYYY'), 'DD/MM/YYYY')
                ],
            listCoursesAssigned: [],
            activeKey: { isActive: true, key: key }
        }))];
        setQuestions(question);
        setSelectedIndex(key);
        setCommunicationProgramStatus(true);
        setOpen(true);
    }

    const selectedQuestion = (param, i) => {
        setSelectedRowKeys([])
        setSelectedRows([])
        setCanEdit(false);

        setCommunicationProgramStatus(true)
        setSelectedIndex(undefined)
        questions.find(i => {
            return i.activeKey.isActive = false;
        });

        const typeSelected = typeof param;
        if (typeSelected === 'undefined') {
            setSelectedIndex(i)
            questions[i].activeKey.isActive = true;
        } else if (typeSelected === 'object') {
            questions[i].activeKey.isActive = true;
            setSelectedIndex(i)
        }
        onChangeQuestion(param.diffusionName, i)

    }

    const deleteDiffusion = (param, index) => {
        selectedQuestion(param, index)
        confirm({
            title: 'Eliminación de Difusión',
            content: '¿Desea eliminar ' + param.diffusionName + ' ?',
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                questions[index].listCoursesAssigned.map(x => x.idCourse).forEach(removeAssigned);

                questions.splice(index, 1);
                //if (typeof param.idDiffusion !== 'undefined') ApiService.deleteDiffusion(param.idDiffusion);
                if (questions.length > 0) {
                    const key = questions.length - 1;
                    setSelectedIndex(key);
                    questions[key].activeKey.isActive = true;
                    selectedQuestion(questions[key], key);

                } else {
                    setOpen(false);
                    setCommunicationProgramStatus(false);
                }
                setQuestions([...questions]);
            },
            onCancel() {

            },
        });
    }

    const generateQuestionList = () => {
        return questions.map((param, i) => (
            <ListItem button className={classes.nested} selected={param.activeKey.isActive} onClick={() => selectedQuestion(param, i)} key={i}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="file" />
                </ListItemIcon>
                <ListItemText secondary={param.diffusionName} />
                <ListItemSecondaryAction>
                    {
                        siteId === 'HUB' ?
                            <IconButton edge="end" onClick={() => deleteDiffusion(param, i)} aria-label="delete">
                                <Icon type="delete" style={styles.addButton} />
                            </IconButton> : null
                    }
                </ListItemSecondaryAction>
            </ListItem>
        ))
    }

    const showConfirm = () => {
        confirm({
            title: '¿Guardar Programa de Comunicación?',
            content: name,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setCommunicationPrograms(
                    {
                        idCommunicationProgram: id,
                        communicationProgramName: name,
                        communicationProgramDescription: description,
                        idSubdirection: employeeData.idSubdirection,
                        idContract: contract === undefined ? null : contract,
                        idWork: work === undefined ? null : work,
                        idTraining: idTraining,
                        totalDiffusion: questions.length,
                        DiplomaRequired: diploma
                    }, 'PUT')
                    .then(
                        response => {
                            if (response.idCommunicationProgram >= 0) {
                                confirm({
                                    title: 'Programa de Comunicación guardado correctamente.',
                                    content: '¿Desea agregar una nueva Difusión?',
                                    okText: 'Continuar',
                                    cancelText: 'Más tarde',
                                    onOk() {
                                        setCommunicationProgramStatus(true);
                                        setOpen(true);
                                        addQuestion();
                                        dispatch(clearCommunicationProgram());
                                        dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                        dispatch(clearcommunicationProgramFilter());
                                        dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                        dispatch(comunicationProgramDiffusionClear());
                                    },
                                    onCancel() {
                                        dispatch(clearCommunicationProgram());
                                        dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                        dispatch(clearcommunicationProgramFilter());
                                        dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                        dispatch(comunicationProgramDiffusionClear());
                                        props.setTab('1')
                                    },
                                });
                            } else {
                                Modal.warning({
                                    title: response.communicationProgramName,
                                    content: 'El nombre del programa de comunicación ya existe.'
                                });
                            }
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() {
                dispatch(clearcommunicationProgramFilter());
                dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
            },
        });
    }

    const size = (text, property = "") => {
        var ret = "";

        if (property !== "") {
            var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === text.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining).filter(w => w.idCommunicationProgram !== props.idCommunicationProgram)
            if (obj !== undefined) {
                if (obj.length > 0) {
                    if (idTraining === undefined && text !== undefined) {
                        ret = " Ya esta asignado";
                    } else {
                        ret = " Ya esta asignado";
                    }
                }
            }
        }
        return ret;
    }

    const csize = (text, property = "") => {
        var ret = "grey";
        if (property !== "") {
            var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === text.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining).filter(w => w.idCommunicationProgram !== props.idCommunicationProgram)
            if (obj !== undefined) {
                if (obj.length > 0) {
                    if (idTraining === undefined && text !== undefined) {
                        ret = "red";
                    } else {
                        ret = "red";
                    }
                }
            }

        }
        return ret;
    }

    const bloqueo = (e) => {
        setDisabledCP(false);


        var obj = allIds.filter(x => x.communicationProgramName.toLowerCase() === name.toLowerCase()).filter(y => y.idSubdirection === employeeData.idSubdirection).filter(z => z.idTraining === idTraining).filter(w => w.idCommunicationProgram !== props.idCommunicationProgram)
        if (obj !== undefined && obj.length > 0) {
            setDisabledCP(true);

        }
    }
    useEffect(() => {
        bloqueo("");
    }, [name, idTraining]);

    const showSecondaryConfirm = () => {
        let isCompleted = true;
        for (var i = 0; i < questions.length; i++) {
            var item = questions[i];

            if (item.diffusionName === "") {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'El Nombre de las difusiones es Requerido' : 'El Nombre de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }

            if (item.vigency[0] === null || item.vigency[1] === null) {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'La Fecha de las difusiones es Requerido' : 'La Fecha de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }

            if (item.listCoursesAssigned.length === 0) {
                Modal.error({
                    title: 'Difusión',
                    content: questions.length > 1 ? 'El procedimiento de las difusiones es Requerido' : 'El procedimiento de la difusión es Requerido',
                });
                isCompleted = false;
                break;
            }
        }

        if (isCompleted)
            confirm({
                title: '¿Guardar Difusión?',
                okText: 'Guardar',
                cancelText: 'Cancelar',
                onOk() {
                    let param = [];
                    questions.forEach((item, index) => {
                        let dateInit = item.vigency[0]._i.split("/")
                        let dateEnd = item.vigency[1]._i.split("/")
                        param.push({
                            "idCommunicationProgram": id,
                            "idDiffusion": item.idDiffusion,
                            "diffusionName": item.diffusionName,
                            "diffusionStartDate": convertDate(`${dateInit[1]}/${dateInit[0]}/${dateInit[2]}`),
                            "diffusionEndDate": convertDate(`${dateEnd[1]}/${dateEnd[0]}/${dateEnd[2]}`),
                            "listCoursesAssigned": item.listCoursesAssigned
                        });
                    })
                    return ApiService.setDiffusion({ idCommunicationProgram: id, diffusion: param }, 'PUT')
                        .then(
                            response => {
                                dispatch(clearCommunicationProgram());
                                dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                dispatch(clearcommunicationProgramFilter());
                                dispatch(fetchCommunicationProgramFilter({ idSubdirection: employeeData.idSubdirection,idEmployee: employeeData.employeeId }));
                                setCommunicationProgramStatus(true);
                                setOpen(true);
                                // setResCommunicationProgram(response);
                                props.setTab('1')
                            }, error => {
                                Modal.error({
                                    title: 'Ops, error de conexión',
                                    content: 'Se perdió la conexión de red, intente más tarde.',
                                });
                            }
                        )
                },
                onCancel() { },
            });
    }

    const deleteAssignedProcedures = () => {
        selectedRowKeys.forEach(removeAssigned);
        questions[selectedIndex].listCoursesAssigned = questions[selectedIndex].listCoursesAssigned.filter(course => !selectedRowKeys.includes(course.idCourse));;
        setSelectedRows([]);
        setSelectedRowKeys([]);
        setCanEdit(false);
    }

    const onChangeQuestion = (value, selected) => {
        questions[selected].diffusionName = value;
        setQuestions([...questions])

        //var obj = questions.filter(x => x != selected).find(y => y.diffusionName.toLowerCase() === value.toLowerCase());
        var obj = [];
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].diffusionName === value && i !== selected) {
                obj.push(questions[i])
            }
        }

        if (obj.length !== 0) {
            setDisableDif(true)
            setShowValid(false)
        } else {
            var tem = [];
            var duplicados = [];
            questions.map(e => tem.push(e.diffusionName))
            var tempQues = [...tem].sort();
            for (var i = 0; i < tempQues.length; i++) {
                if (tempQues[i + 1] === tempQues[i]) {
                    duplicados.push(tempQues[i]);
                }
            }
            if (duplicados.length !== 0) {
                setDisableDif(true);

            } else {
                setDisableDif(false);
            }

            setShowValid(true)
        }


    }

    const onChangeCourses = (keys, rows) => {
        rows.forEach((item) => {
            questions[selectedIndex].listCoursesAssigned.push({
                ...item,
                category: true,
                file: false,
                external: false,
                notApply: false,
                listEmployeeFile: [],
                listEmployeeExternal: []
            });
        })

        setQuestions([...questions])
    }

    const onChangeVigency = (date, dateString) => {
        if (dateString[0] !== "")
            questions[selectedIndex].vigency = [moment(dateString[0], 'DD/MM/YYYY'), moment(dateString[1], 'DD/MM/YYYY')];
        else
            questions[selectedIndex].vigency = [null, null];
        setQuestions([...questions])
    }

    const openEditAssignmentModal = () => {



        if (selectedRowKeys.length > 1) {
            setEmployeesAssigFile([]);
            setEmployeesAssigExternal([]);
            setNotApply(false);
        }
        else {
            setEmployeesAssigFile(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).listEmployeeFile);
            setEmployeesAssigExternal(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).listEmployeeExternal);
            setNotApply(questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === selectedRowKeys[0]).notApply);
        }

        setVisibleModalEditAssignment(true);
        dispatch(getEmployeesBycategory(
            {
                idCourse: selectedRowKeys.join(','),
                idContract: contract === undefined ? null : contract,
                idWork: work === undefined ? null : work
            })
        );
        dispatch(getEmployeesByIdEmployee({
            idCourse: selectedRowKeys.join(','),
            idContract: contract === undefined ? null : contract,
            idWork: work === undefined ? null : work,
            isAdmin: IsAdmin()
        }));

        if (idTraining === "TK0000000002") {
            handleTabChange('2');
        }
    }

    const disabledDateVigency = (current) => {
        let totalDiffusion = questions.length;

        if (totalDiffusion === 1) {
            return false;
        }
        else {
            if (selectedIndex === 0) { //Primera difusión
                if (current > moment(questions[selectedIndex + 1].vigency[0]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            }
            else if (selectedIndex === (totalDiffusion - 1)) { //Ultima difusión
                if (current < moment(questions[selectedIndex - 1].vigency[1]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            } else { //En medio de difusiones
                if (current < moment(questions[selectedIndex - 1].vigency[1]._i, 'DD-MM-YYYY') || current > moment(questions[selectedIndex + 1].vigency[0]._i, 'DD-MM-YYYY')) { return true }
                else { return false }
            }
        }
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = (clearFilters, setSelectedKeys) => {
        setSelectedKeys([]);
        setSearchText('');
    };



    const handleTabChange = (tab) => {
        setTabBar(tab);
    }



    const onSelectChangeAvailableFile = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFile(selectedRows);
        setSelectedRowKeysAvailableFile(selectedRowKeys);
        setSelectedRowsFile(selectedRows);
        setSelectedRowKeysFile(selectedRowKeys);
    }


    const rowSelectionAvailableFile = {
        selectedRowKeys: selectedRowKeysFile,
        selectedRows: selectedRowsFile,
        onChange: onSelectChangeAvailableFile
    }

    const onSelectChangeAvailableFileAssig = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableFileAssig(selectedRows);
        setSelectedRowKeysAvailableFileAssig(selectedRowKeys);
        setSelectedRowsFileAssig(selectedRows);
        setSelectedRowKeysFileAssig(selectedRowKeys);
    }


    const rowSelectionAvailableFileAssig = {
        selectedRowKeys: selectedRowKeysFileAssig,
        selectedRows: selectedRowsFileAssig,
        onChange: onSelectChangeAvailableFileAssig
    }

    const onSelectChangeAvailableExternal = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableExternal(selectedRows);
        setSelectedRowKeysAvailableExternal(selectedRowKeys);
        setSelectedRowsExternal(selectedRows);
        setSelectedRowKeysExternal(selectedRowKeys);
    }


    const rowSelectionAvailableExternal = {
        selectedRowKeys: selectedRowKeysExternal,
        selectedRows: selectedRowsExternal,
        onChange: onSelectChangeAvailableExternal
    }

    const onSelectChangeAvailableExternalAssig = (selectedRowKeys, selectedRows) => {
        setSelectedRowsAvailableExternalAssig(selectedRows);
        setSelectedRowKeysAvailableExternalAssig(selectedRowKeys);
        setSelectedRowsExternalAssig(selectedRows);
        setSelectedRowKeysExternalAssig(selectedRowKeys);
    }

    const rowSelectionAvailableExternalAssig = {
        selectedRowKeys: selectedRowKeysExternalAssig,
        selectedRows: selectedRowsExternalAssig,
        onChange: onSelectChangeAvailableExternalAssig
    }

    const onChangeSelection = (keys, rows) => {
        setSelectedRowKeys(keys)
        setSelectedRows(rows)
        setCanEdit(true);

        if (rows.length > 1) {
            if (rows.reduce((prev, next) => (next.file ? (prev + 1) : prev), 0) > 0) {
                setCanEdit(false);
            } else if (rows.reduce((prev, next) => (next.external ? (prev + 1) : prev), 0) > 0) {
                setCanEdit(false);
            } else {
                setCanEdit(true);
            }
        } else if (rows.length === 0) {
            setCanEdit(false);
        }
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        selectedRows: selectedRows,
        onChange: onChangeSelection
    }

    const assignEmployeeFile = () => {
        setEmployeesAssigFile([...employeesAssigFile, ...selectedRowsAvailableFile]);
        setSelectedRowsAvailableFile([]);
        setSelectedRowKeysAvailableFile([]);
        setSelectedRowsFile([]);
        setSelectedRowKeysFile([]);
    }

    const assignEmployeeExternal = () => {
        let listOk = selectedRowsAvailableExternal.filter(x => moment(x.expirationDate).isSameOrAfter(moment().add(3, 'days')) && x.rol);
        if (listOk.length !== selectedRowsAvailableExternal.length) {
            let total = selectedRowsAvailableExternal.length - listOk.length;
            if (total === 1) {
                message.warning("El empleado no asignado no cumple con la vigencia o el rol, favor de validar");
            }
            else {
                message.warning("Los empleados no asignados no cumplen con la vigencia o el rol, favor de validar");
            }
        }

        setEmployeesAssigExternal([...employeesAssigExternal, ...listOk]);
        setSelectedRowKeysAvailableExternal([...selectedRowKeysAvailableExternal.filter(x => !listOk.map(y => y.employeeId).includes(x))]);
        setSelectedRowsAvailableExternal([...selectedRowsAvailableExternal.filter(x => !listOk.includes(x))]);
        setSelectedRowKeysExternal([...selectedRowKeysExternal.filter(x => !listOk.map(y => y.employeeId).includes(x))]);
        setSelectedRowsExternal([...selectedRowsExternal.filter(x => !listOk.includes(x))]);
    }

    const removeEmployeeExternal = () => {
        setEmployeesAssigExternal(employeesAssigExternal.filter(x => !selectedRowKeysAvailableExternalAssig.includes(x.employeeId)));
        setSelectedRowsAvailableExternalAssig([]);
        setSelectedRowKeysAvailableExternalAssig([]);
        setSelectedRowsExternalAssig([]);
        setSelectedRowKeysExternalAssig([]);
    }

    const removeEmployeeFile = () => {
        setEmployeesAssigFile(employeesAssigFile.filter(x => !selectedRowKeysAvailableFileAssig.includes(x.employeeId)))
        setSelectedRowsAvailableFileAssig([]);
        setSelectedRowKeysAvailableFileAssig([]);
        setSelectedRowsFileAssig([]);
        setSelectedRowKeysFileAssig([]);
    }

    const updateAssig = () => {
        selectedRowKeys.forEach((item) => {
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).notApply = notApply;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).category = !notApply;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).file = employeesAssigFile.length > 0;
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).external = employeesAssigExternal.length > 0;

            if (selectedRowKeys.length > 1) {
                const employeeAsig = employeesAssigFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                const employeeNew = questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                const employeeLayout = dataExcel.map(item => ({
                    // categoryName: item.category,
                    // companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                let set = new Set([...employeeAsig, ...employeeNew,...employeeLayout].map(JSON.stringify))
                questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile = Array.from(set).map(JSON.parse);;
            }
            else {
                const employeeAsig = employeesAssigFile.map(item => ({
                    categoryName: item.categoryName,
                    companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                const employeeLayout = dataExcel.map(item => ({
                    // categoryName: item.category,
                    // companyName: item.companyName,
                    employeeId: item.employeeId,
                    fullName: item.fullName,
                    key: item.employeeId
                }))
                let set = new Set([...employeeAsig,...employeeLayout].map(JSON.stringify))
                questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeFile = Array.from(set).map(JSON.parse);//employeesAssigFile;
            }
            questions[selectedIndex].listCoursesAssigned.find(x => x.idCourse === item).listEmployeeExternal = employeesAssigExternal;
        });
        setVisibleModalEditAssignment(false);
    }

    const checkEdit = () => {
        if (selectedRowKeys?.length > 0 && idTraining === "TK0000000002" && canEdit == false) {
            // handleTabChange(2)
            return false
        }
        return !canEdit;
    }

    const convertDate = (payload) => {
        var dateObject = new Date(payload);
        return dateObject;
    }

    useEffect(() => {
        if (questions.length > 0) {
            setIsLoadedDiffusion(true);
        }

        if (name !== '') setLoadData(true);
        if (diploma === undefined) setDiploma(props.editParam.diplomaRequired)

        if (questions.length === 0 && !isLoadedDiffusion) {
            setQuestions(props.communicationProgramsDiffusion);
        }
        if (name === '' && !isLoaded) {
            setName(props.editParam.communicationProgramName);
            setDesc(props.editParam.communicationProgramDescription)
            setId(props.editParam.idCommunicationProgram);
            setEstatus(props.editParam.statusName);
            setFolio(props.editParam.cpFolio);
            setOilService(props.editParam.idSubdirection === 3 && (props.editParam.idTraining === 'TK0000000001' || props.editParam.idTraining === 'TK0000000002') ? true : false)
            setIdTraining(props.editParam.idTraining);
            setOilTraining(props.editParam.idTraining === "TK0000000001" || props.editParam.idTraining === "TK0000000002");
            setContract(props.editParam.idContract);
            setWork(props.editParam.idWork);
            setLoadData(true);
        }
        if (questions.length > 0 && typeof selectedIndex === 'undefined') {
            setSelectedIndex(questions.length - 1)
            setOpen(true);
        }
    })

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const IsAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Administrador')) {
                return true;
            }
        }
        return false;
    }

    const roleAllowed = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Supervisor de aseguramiento de calidad'))
                return true;
        }
        return false;
    }

    const handleDownloadLayout = () => {
        dispatch(getEmployeeLayout("LayoutColaborador.xlsx"));

        //     getEmployeeLayout,
        // postEmployeeLayout,
    }


    return (
        <div>
            <Spin spinning={isLoadingDiffusion}>
                <Grid container direction="row">
                    <Grid xs={4} item>
                        <CardContent>
                            <div>
                                <List
                                    aria-labelledby="nested-list-subheader"
                                    className={classes.principalRoot}
                                    component="nav"
                                    subheader={
                                        siteId === 'HUB' ?
                                            <ListSubheader component="div" id="nested-list-subheader">
                                                <ListItem button className={classes.justifyContentFlexEnd} disabled={disableDif || disabledCP} onClick={() => addQuestion()}>
                                                    <ListItemIcon className={classes.icon}>
                                                        <Icon style={{ fontSize: '20px' }} type='plus-circle' theme='twoTone' />
                                                    </ListItemIcon>
                                                    <TextEvents
                                                        text='Nueva Difusión'
                                                        color='gray'
                                                        size='small'
                                                        weight='regular'
                                                    />
                                                </ListItem>
                                            </ListSubheader> : null
                                    }
                                >
                                </List>
                                <Divider />
                                <List dense={false}>
                                    <ListItem button disabled={!open} onClick={() => setCommunicationProgramStatus(false)}>
                                        <ListItemIcon className={classes.icon}>
                                            <Icon type="folder" />
                                        </ListItemIcon>
                                        <ListItemText primary={name} className={classes.itemText} />
                                        {isCommunicationProgram ? <ListItemSecondaryAction onClick={handleClick}>
                                            {open ? <Icon type="down" /> : <Icon type="up" />}
                                        </ListItemSecondaryAction> : <div />}
                                    </ListItem>
                                </List>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {questions.length > 0 ? generateQuestionList() : ''}
                                    </List>
                                </Collapse>
                            </div>
                        </CardContent>
                    </Grid>
                    {!isCommunicationProgram ?
                        <Grid xs={8} item>
                            <Card className={classes.card}>
                                <CardContent>
                                    <div className={classes.content}>
                                        <Grid container direction="row">
                                            <Grid xs={6} item className={classes.gridSeparatorRight}>
                                                <TextInput
                                                    value={folio}
                                                    disabled
                                                    text='Folio'
                                                    mode='input'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    placeholder=""
                                                >
                                                </TextInput>
                                            </Grid>
                                            <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                                <TextInput
                                                    disabled
                                                    text='Estatus'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode="multiple"
                                                    placeholder="Edición"
                                                    value={estatus}
                                                >
                                                </TextInput>
                                            </Grid>
                                            <Grid xs={12} item >

                                                <Grid item xs={12}>
                                                    <TextEvents
                                                        text='Subdirección Origen'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                    />

                                                    <SubdirectionsContainer>

                                                        {(params) => {
                                                            return (
                                                                <Select
                                                                    disabled
                                                                    labelInValue
                                                                    defaultValue={{ key: String(props.editParam.idSubdirection) }}
                                                                    style={{ width: "100%" }}
                                                                >
                                                                    {(employeeData.idSubdirection === 3) ? setOilService(true) : setOilService(false)}
                                                                    {
                                                                        params.subdirs.map((item) => {
                                                                            return (
                                                                                <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                    {item.subdirectionName}
                                                                                </Select.Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            )
                                                        }}
                                                    </SubdirectionsContainer>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <TextEvents
                                                        text='Tipo de capacitación'
                                                        color="darker"
                                                        size='label'
                                                        weight="medium"
                                                    />
                                                    <Select
                                                        disabled={true}
                                                        loading={isLoadTrainingSelect}
                                                        placeholder="Seleciona tipo de capacitación"
                                                        showSearch
                                                        value={idTraining}
                                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                        optionFilterProp="Children"
                                                        filterOption={(input, option) =>
                                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {optionTraining}
                                                    </Select>
                                                </Grid>

                                                {oilService && oilTraining ? <Grid item xs={12}>
                                                    <TextEvents
                                                        text='Contrato'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                    />
                                                    <ContractContainer>
                                                        {(params) => {
                                                            return (
                                                                <Select
                                                                    disabled={true}
                                                                    placeholder='Selecciona contrato'
                                                                    value={contract}
                                                                    allowClear
                                                                    showSearch
                                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                                    optionFilterProp="Children"
                                                                    filterOption={(input, option) =>
                                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                >
                                                                    {
                                                                        params.contract.map((item) => {
                                                                            return (
                                                                                <Select.Option key={item.idContract} value={item.idContract}>
                                                                                    {item.contractName}
                                                                                </Select.Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            )
                                                        }}
                                                    </ContractContainer>
                                                </Grid> : null}

                                                {oilService && oilTraining ? <Grid item xs={12}>
                                                    <TextEvents
                                                        text='OT'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                        placeholder='Selecciona OT'
                                                    />
                                                    <WorkContainer contract={contract}>
                                                        {(params) => {
                                                            return (
                                                                <Select
                                                                    disabled={true}
                                                                    placeholder='Selecciona obra'
                                                                    value={work}
                                                                    allowClear
                                                                    showSearch
                                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                                    optionFilterProp="Children"
                                                                    filterOption={(input, option) =>
                                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                >
                                                                    {
                                                                        params.work.map((item) => {
                                                                            return (
                                                                                <Select.Option key={item.idWork} value={item.idWork}>
                                                                                    {item.ot}
                                                                                </Select.Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>

                                                            )
                                                        }}
                                                    </WorkContainer>
                                                </Grid> : null}

                                                <TextInput
                                                    value={name}
                                                    setValue={setName}
                                                    disabled={siteId !== 'HUB'}
                                                    text='Nombre'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    placeholder='Nombre'
                                                    tamano={size(name, "names")}
                                                    tcolor={csize(name, "names")}

                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                    <div>
                                        <TextEvents
                                            text='Descripción'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <TextArea
                                            disabled={siteId !== 'HUB'}
                                            value={description}
                                            onChange={e => setDesc(e.target.value)}
                                            autoSize={{ minRows: 5, maxRows: 6 }}
                                            placeholder='Descripción'
                                        />
                                        <Checkbox checked={diploma} onChange={(e) => { setDiploma(e.target.checked) }}>Requiere Diploma</Checkbox>
                                    </div>
                                    <div className={classes.buttonsContainer}>
                                        {
                                            siteId === 'HUB' ?
                                                <Button
                                                    variant='contained'
                                                    type='primary'
                                                    onClick={showConfirm}
                                                    disabled={name === '' || disabledCP || disableDif}
                                                > Guardar</Button> : null
                                        }
                                        <Button
                                            type="danger" 
                                            ghost
                                            variant='contained'
                                            className={classes.button}
                                            onClick={() => props.setTab('1')}
                                        >Cancelar</Button>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>

                        :
                        <Grid xs={8} item>
                            <Card className={classes.card}>
                                <CardContent>
                                    <div className={classes.content}>
                                        {typeof questions !== 'undefined' ?
                                            <div>
                                                <Grid container direction="row">
                                                    <Grid xs={12} item className={classes.gridSeparatorRight}>
                                                        <Grid container>
                                                            <Grid item>
                                                                <TextEvents
                                                                    text='Nombre '
                                                                    color='darker'
                                                                    size='label'
                                                                    weight='medium'

                                                                />
                                                            </Grid>
                                                            <div hidden={showValid}>
                                                                <Grid item style={{ marginLeft: '10px' }}>
                                                                    <TextEvents
                                                                        text=' Ya esta asignado'
                                                                        color='red'
                                                                        size="5px"
                                                                        style="text-align: right !important, margin-left: 12px;"

                                                                    />
                                                                </Grid>
                                                            </div>
                                                        </Grid>
                                                        <TextArea
                                                            disabled={siteId !== 'HUB'}
                                                            value={questions[selectedIndex].diffusionName}
                                                            onChange={e => onChangeQuestion(e.target.value, selectedIndex)}

                                                            autoSize={{ minRows: 1, maxRows: 1 }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container direction="row">
                                                    <Grid xs={12} item >
                                                        <TextEvents
                                                            text='Selecciona Fecha'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                        />

                                                        <RangePicker
                                                            disabled={siteId !== 'HUB'}
                                                            format="DD/MM/YYYY"
                                                            disabledDate={disabledDateVigency}
                                                            value={questions[selectedIndex].vigency}
                                                            onChange={(date, dateString) => {
                                                                onChangeVigency(date, dateString);
                                                            }}


                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container direction="row" className={classes.gridSeparatorTop} >
                                                    <Grid xs={10} item >
                                                        {
                                                            siteId === 'HUB' ?
                                                                <Tooltip placement="bottom" title={'Agregar Procedimiento/Material de capacitación'}>
                                                                    <IconButton className={classes.editIcon} onClick={() => setVisibleModalProcedureAssign(true)}>
                                                                        <Icon type="plus-square" />
                                                                    </IconButton>
                                                                </Tooltip> : null
                                                        }

                                                    </Grid>
                                                    {questions[selectedIndex].listCoursesAssigned?.length > 0 ?
                                                        <Grid xs={2} item >
                                                            {
                                                                siteId === 'HUB' ?
                                                                    <Tooltip placement="bottom" title={'Eliminar procedimiento(s) seleccionado(s)'}>
                                                                        <IconButton disabled={!selectedRowKeys?.length > 0} className={classes.deleteIcon} onClick={deleteAssignedProcedures}>
                                                                            <Icon type="delete" />
                                                                        </IconButton>
                                                                    </Tooltip> : null
                                                            }
                                                            <Tooltip placement="bottom" title={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ? 'Editar procedimiento(s)' : 'Visualizar procedimiento(s)'}>
                                                                <IconButton disabled={checkEdit()} className={classes.editIcon} onClick={openEditAssignmentModal}>
                                                                    <Icon type={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ? "edit" : "eye"} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid> : null}
                                                </Grid>

                                                <Grid container direction="row" className={classes.gridSeparatorTop} >
                                                    <Grid xs={12} item >
                                                        <CourseAvailableContainer id={id}>
                                                            {
                                                                (params) => {
                                                                    return (
                                                                        <ModalProcedureAssignation
                                                                            courseAvailable={params.courseAvailables}
                                                                            setVisibleModalProcedureAssign={setVisibleModalProcedureAssign}
                                                                            visibleModalProcedureAssign={visibleModalProcedureAssign}
                                                                            isLoadingCourses={false}
                                                                            isLoadingSaveCourses={false}
                                                                            onChangeCourses={onChangeCourses}
                                                                        />
                                                                    )
                                                                }
                                                            }
                                                        </CourseAvailableContainer>
                                                    </Grid>
                                                </Grid>

                                                <Table
                                                    columns={columns}
                                                    dataSource={dataSourceCourse}
                                                    scroll={{ x: "min-content", y: 250 }}
                                                    rowSelection={rowSelection}
                                                    pagination={false}
                                                    size={"small"}
                                                />

                                                {
                                                    visibleModalEditAssignment ?
                                                        <div>
                                                            <Modal
                                                                visible={visibleModalEditAssignment}
                                                                onCancel={() => setVisibleModalEditAssignment(false)}
                                                                width={'900px'}
                                                                centered={true}
                                                                footer={
                                                                    siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ?
                                                                        [
                                                                            <Button key="submit" type="primary" onClick={updateAssig} >
                                                                                Guardar
                                                                            </Button>,
                                                                            <Button key="back" type="danger" ghost onClick={() => setVisibleModalEditAssignment(false)}>
                                                                                Cancelar
                                                                            </Button>
                                                                        ] :
                                                                        [
                                                                            <Button key="back" type="danger" ghost onClick={() => { setVisibleModalEditAssignment(false); setDataExcel([]) }}>
                                                                                Cancelar
                                                                            </Button>
                                                                        ]
                                                                }
                                                            >
                                                                <Tabs type='card' tabBarStyle={{ margin: 0 }} activeKey={activeKey} defaultActiveKey='1' onChange={tab => (handleTabChange(tab))}>
                                                                    <TabPane tab='Por Puesto' key='1' disabled={idTraining === "TK0000000002"}>
                                                                        <Paper className={classes.paper} key='1'>
                                                                            <br></br>
                                                                            <Grid container direction="row">
                                                                                <Grid item xs={3}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Asignados'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={7}>
                                                                                    <TextEvents
                                                                                        text={`${listEmployeesByCategory.length} elementos`}
                                                                                        color='gray'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                    <Checkbox disabled={siteId !== 'HUB'} checked={notApply} onChange={(e) => { setNotApply(e.target.checked) }}>No aplica</Checkbox>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <Grid container direction="row">
                                                                                <Grid item xs={12}>
                                                                                    <Table
                                                                                        columns={columnsCategory}
                                                                                        dataSource={dataSourceCategories}
                                                                                        scroll={{ y: 300 }}
                                                                                        loading={isLoadingEmployeesByCatagory}
                                                                                        size="small"
                                                                                        rowClassName={notApply ? classes.disabledTable : ''}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Paper>
                                                                    </TabPane>
                                                                    <TabPane tab='Por Ficha' key='2'>
                                                                        <Paper className={classes.paper} key='2'>
                                                                            <Grid container direction="row">
                                                                                <Grid item xs={12}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Por Asignar'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Table
                                                                                        columns={columnsCategoryFile}
                                                                                        dataSource={dataSourceFile}
                                                                                        scroll={{ y: 150 }}
                                                                                        loading={isLoadListEmployeesById}
                                                                                        rowSelection={rowSelectionAvailableFile}
                                                                                        size="small"
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>

                                                                            <Row gutter={[12, 8]}>
                                                                                <Col span={12} align="right">
                                                                                    <Tooltip placement="bottom" title={'Asignar colaborador'}>
                                                                                        <IconButton disabled={siteId !== 'HUB' && (siteId !== 'HUB' && roleAllowed() === false)} className={classes.editIcon} onClick={assignEmployeeFile}>
                                                                                            <Icon type="down" />
                                                                                        </IconButton>
                                                                                    </Tooltip>

                                                                                </Col>

                                                                                <Col span={12}>
                                                                                    <Tooltip placement="bottom" title={'Designar colaborador'}>
                                                                                        <IconButton disabled={siteId !== 'HUB' && (siteId !== 'HUB' && roleAllowed() === false)} className={classes.editIcon} onClick={removeEmployeeFile}>
                                                                                            <Icon type="up" />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </Col>
                                                                            </Row>

                                                                            <Grid container direction="row">
                                                                                <Grid item xs={3}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Asignados'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={9}>
                                                                                    <TextEvents
                                                                                        text={`${employeesAssigFile.length} ${employeesAssigFile.length === 1 ? "elemento" : "elementos"}`}
                                                                                        color='gray'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Table
                                                                                        columns={columnsCategory}
                                                                                        dataSource={dataSourceFileAssig}
                                                                                        scroll={{ y: 150, /*x: 400*/ }}
                                                                                        rowSelection={rowSelectionAvailableFileAssig}
                                                                                        size="small"
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>

                                                                        </Paper>
                                                                    </TabPane>
                                                                    <TabPane tab='Externo' key='3'>
                                                                        <Paper className={classes.paper} key='3'>
                                                                            <Grid container direction="row">
                                                                                <Grid item xs={12}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Por Asignar'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Table
                                                                                        columns={columnsExternal}
                                                                                        dataSource={dataSourceExternal}
                                                                                        scroll={{ y: 150, x: "min-content" }}
                                                                                        loading={isLoadingExternalEmployees}
                                                                                        rowSelection={rowSelectionAvailableExternal}
                                                                                        size="small"
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>

                                                                            <Row gutter={[12, 8]}>
                                                                                <Col span={12} align="right">
                                                                                    <Tooltip placement="bottom" title={'Asignar colaborador'}>
                                                                                        <IconButton disabled={siteId !== 'HUB'} className={classes.editIcon} onClick={assignEmployeeExternal}>
                                                                                            <Icon type="down" />
                                                                                        </IconButton>
                                                                                    </Tooltip>

                                                                                </Col>

                                                                                <Col span={12}>
                                                                                    <Tooltip placement="bottom" title={'Designar colaborador'}>
                                                                                        <IconButton disabled={siteId !== 'HUB'} className={classes.editIcon} onClick={removeEmployeeExternal}>
                                                                                            <Icon type="up" />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </Col>
                                                                            </Row>

                                                                            <Grid container direction="row">
                                                                                <Grid item xs={3}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Asignados'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={9}>
                                                                                    <TextEvents
                                                                                        text={`${employeesAssigExternal.length} ${employeesAssigExternal.length === 1 ? "elemento" : "elementos"}`}
                                                                                        color='gray'
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <Table
                                                                                        columns={columnsExternal}
                                                                                        dataSource={dataSourceExternalAssig}
                                                                                        scroll={{ y: 150, x: 400 }}
                                                                                        rowSelection={rowSelectionAvailableExternalAssig}
                                                                                        size="small"
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Paper>
                                                                    </TabPane>
                                                                    <TabPane tab='Layout' key='4'>
                                                                        <Paper className={classes.paper} key='4'>
                                                                            <Grid container direction="row" spacing={1}>
                                                                                <Grid item xs={6}>
                                                                                    <TextEvents
                                                                                        text={'Colaboradores Por Asignar'}
                                                                                        color='cotemar'
                                                                                        size='label'
                                                                                        weight='bold'
                                                                                    />
                                                                                    <Grid item xs={7}>
                                                                                        <TextEvents
                                                                                            text={`${dataExcel.length} elementos`}
                                                                                            color='gray'
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item xs={6} align="right">
                                                                                    <Button
                                                                                        className={classes.button}
                                                                                        variant="contained"
                                                                                        type="primary"
                                                                                        onClick={() => handleDownloadLayout()}
                                                                                    >
                                                                                        Descargar Layout
                                                                                    </Button>
                                                                                </Grid>

                                                                                <Grid item xs={12}>
                                                                                    {
                                                                                        dataExcel.length > 0 ?
                                                                                            <Table
                                                                                                columns={columnsLayout}
                                                                                                dataSource={dataExcel}
                                                                                                scroll={{ y: 150, x: "min-content" }}
                                                                                                loading={isLoadingLayout}
                                                                                                size="small"
                                                                                                rowClassName={''}
                                                                                            /> : <AttachFileXLSX
                                                                                                setAttachment={setAttachment}
                                                                                                localAttachment={localAttachment}
                                                                                                loadDocument={loadDocument}
                                                                                                setLoadDocument={setLoadDocument}
                                                                                                setDataExcel={setDataExcel}
                                                                                                dataExcel={dataExcel}
                                                                                                idCourse={selectedRowKeys}
                                                                                            >
                                                                                                {
                                                                                                    (params => {
                                                                                                        return <div />
                                                                                                    })
                                                                                                }
                                                                                            </AttachFileXLSX>
                                                                                    }



                                                                                </Grid>
                                                                            </Grid>

                                                                        </Paper>
                                                                    </TabPane>
                                                                </Tabs>
                                                            </Modal>
                                                        </div> : null
                                                }
                                            </div>
                                            : ''
                                        }
                                    </div>
                                </CardContent>
                            </Card>
                            <div className={classes.buttonsContainer}>
                                {
                                    siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ?
                                        <Button
                                            variant='contained'
                                            type='primary'
                                            onClick={showSecondaryConfirm}
                                            disabled={questions.length <= 0 || disableDif || disabledCP}
                                        > Guardar</Button> : null
                                }
                                <Button
                                    type="danger" 
                                    ghost
                                    variant='contained'
                                    className={classes.button}
                                    onClick={() => props.setTab('1')}
                                >Cancelar</Button>
                            </div>
                        </Grid>
                    }
                </Grid>
            </Spin>
        </div>
    )
}